import { useState, useEffect, useContext } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SyncIcon from "@mui/icons-material/Sync";
import {
  useGetCompanyWatchers,
  useCreateCompanyWatcher,
  useDeleteCompanyWatcher,
} from "models/company_watchers/apiCompanyWatchers";
import { ConstantContext } from "components/context/ConstantProvider";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { UserContext } from "components/context/UserProvider";

const CompanyWatcher = ({ companyId }) => {
  const { mutate: createWatcher } = useCreateCompanyWatcher();
  const { mutate: deleteWatcher } = useDeleteCompanyWatcher();
  const { users } = useContext(ConstantContext);
  const { user } = useContext(UserContext);

  const [watcherList, setWatcherList] = useState(null);
  const [currentUserWatcher, setCurrentUserWatcher] = useState(undefined);
  const { data: watchers, error, isSuccess } = useGetCompanyWatchers(companyId);

  useEffect(() => {
    if (isSuccess) {
      setCurrentUserWatcher(
        watchers.find((watcher) => watcher.user_id === user.id) || null,
      );
      setWatcherList(
        <div>
          <Typography>Watchers:</Typography>
          {watchers.map((watcher, index) => {
            const user = users.find((u) => u.id === watcher.user_id);
            return (
              <p key={`w-${index}`}>{user ? user.fullname : watcher.user_id}</p>
            );
          })}
        </div>,
      );
    }
  }, [watchers, user, isSuccess]);

  const handleIconClick = () => {
    if (currentUserWatcher) {
      deleteWatcher(currentUserWatcher.id);
    } else if (currentUserWatcher === null) {
      createWatcher({ companyId, userId: user.id });
    }
  };

  if (error) {
    return (
      <Tooltip title={error}>
        <IconButton disabled>
          <SyncIcon sx={{ color: "error.main" }} />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <>
      <style jsx>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
      <Tooltip title={watcherList}>
        {currentUserWatcher === undefined ? (
          <span>
            <IconButton disabled>
              <SyncIcon style={{ animation: "spin 1s linear infinite" }} />
            </IconButton>
          </span>
        ) : currentUserWatcher !== null ? (
          <IconButton onClick={handleIconClick}>
            <VisibilityIcon />
          </IconButton>
        ) : (
          <IconButton onClick={handleIconClick}>
            <VisibilityIcon style={{ opacity: 0.5 }} />
          </IconButton>
        )}
      </Tooltip>
    </>
  );
};

export default CompanyWatcher;
